import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { ArrowDropDown, Delete } from '@mui/icons-material';
import DatePicker from '../../AutoOpenDatePicker';
import { Box, Collapse, IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reloadTable } from '../../../actions/AsyncTable';
import { EditBracelet, GetActiveBracelets } from '../../../actions/bracelets';
import { closeRequestModal, openRequestModal } from '../../../actions/modals';
import { getInfo } from '../../../actions/toast';
import { BRACELETS } from '../../../constants/bracelet';
import logo_by from '../../../resources/img/logo/by.png';
import logo_en from '../../../resources/img/logo/en.png';
import logo_ro from '../../../resources/img/logo/ro.png';
import logo_ru from '../../../resources/img/logo/ru.png';
import logo_ua from '../../../resources/img/logo/ua.png';
import logo_ee from '../../../resources/img/logo/ее.png';

const logo = {
    ru: logo_ru,
    ua: logo_ua,
    en: logo_en,
    ee: logo_ee,
    ro: logo_ro,
    by: logo_by,
    de: logo_en,
};

const logoImgWidth = '60px';

const Bracelet = ({ selectBracelet, bracelet, logo, i18n, i, style = {}, date }) => {
    if (!bracelet) return null;
    return (
        <Button
            p={1}
            style={{
                width: '100%',

                backgroundColor: bracelet.color,
                display: 'flex',
                justifyContent: 'space-around',
                alignContent: 'center',
                flexWrap: 'wrap',
                borderRadius: '7px',
                padding: '14px',
                position: 'relative',
                boxShadow:
                    bracelet.label === 'White'
                        ? '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'
                        : 'unset',
                ...style,
            }}
            onClick={() => (selectBracelet ? selectBracelet(bracelet) : null)}
        >
            <img width={logoImgWidth} alt={`SOROBAN bracelet logo 1 ${bracelet.label}`} src={logo[i18n.language]} />
            <img width={logoImgWidth} alt={`SOROBAN bracelet logo 2 ${bracelet.label}`} src={logo[i18n.language]} />

            {date && (
                <Typography
                    sx={{
                        color: bracelet.label === 'White' ? 'black' : 'white',
                        position: 'absolute',
                        bottom: '-3px',
                        right: '50%',
                        transform: 'translateX(50%)',
                    }}
                    variant="caption"
                >
                    {' '}
                    {new Date(date).toLocaleString()}
                </Typography>
            )}
        </Button>
    );
};

const EditStudentBracelet = props => {
    const { t, i18n } = props;
    const [braceletInfo, setBraceletInfo] = useState(null);
    const [listControl, setListControl] = useState(false);
    const [oldBracelet, setlOldBracelet] = useState('');
    const [allActiveBracelets, setAllActiveBracelets] = useState([]);
    const [activationDate, setActivationDate] = useState(null);
    const dispatch = useDispatch();

    const fetchBraceletsInfo = async () => {
        const res = await GetActiveBracelets(props.data.id);
        try {
            if (!res) return false;

            setAllActiveBracelets(res.list);
            if (!res.active.bracelet) {
                setListControl(true);
            }

            setlOldBracelet(res.active);
            return true;
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchBraceletsInfo();
    }, []);

    const selectBracelet = bracelet => {
        const existingBracelet = allActiveBracelets.find(el => el.bracelet === bracelet.label);

        if (existingBracelet && existingBracelet.date) {
            getInfo(t('bracelets.bracelet_already_exists'));
        }
        setActivationDate(null);
        const newItem = structuredClone({
            student_id: props.data.id,
            bracelet: bracelet.label,
            selected: true,
        });
        setBraceletInfo(newItem);
        setListControl(false);
    };

    const editUser = async () => {
        delete braceletInfo.selected;

        const selectedDate = new Date(activationDate);
        const now = new Date();

        selectedDate.setHours(now.getHours());
        selectedDate.setMinutes(now.getMinutes());
        selectedDate.setSeconds(now.getSeconds());
        selectedDate.setMilliseconds(now.getMilliseconds());

        const data = {
            student_id: braceletInfo.student_id,
            bracelet: braceletInfo.bracelet,
            date: selectedDate.toISOString(),
        };
        await EditBracelet(data);
        setBraceletInfo(null);
        setActivationDate(null);
        setListControl(false);
        await fetchBraceletsInfo();
        await dispatch(reloadTable());
    };

    const handleDeleteBracelet = bracelet => {
        if (!bracelet) return;

        const prevBracelet = allActiveBracelets.find(el => el.bracelet === bracelet.label);

        if (!prevBracelet) {
            getInfo(t('bracelets.bracelet_not_activated'));
            return;
        }

        dispatch(
            openRequestModal({
                opened: true,
                data: {
                    bracelet: bracelet.label,
                    student_id: props.data.id,
                    header: t('bracelets.confirmDelete'),
                    modaltype: 'DeleteBracelet',
                    callBackDataHW: async () => {
                        await fetchBraceletsInfo();
                    },
                    parentModalData: {
                        id: props.data.id,
                        header: props.data.header || t('bracelets.Bracelet Control'),
                        modaltype: 'EditStudentBracelet',
                    },
                },
            })
        );
    };

    const selectedBracelet = braceletInfo && braceletInfo.bracelet;

    return (
        <Box>
            <Stack spacing={1}>
                <Collapse in={typeof oldBracelet?.bracelet === 'string' && oldBracelet?.bracelet !== ''}>
                    <Box>
                        <Typography variant={'caption'} textAlign={'left'}>
                            {t('bracelets.Current Bracelet')}
                        </Typography>
                    </Box>
                </Collapse>

                {typeof oldBracelet?.bracelet === 'string' && oldBracelet?.bracelet !== '' ? (
                    <Box
                        sx={{
                            position: 'relative',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Bracelet
                            i18n={i18n}
                            bracelet={BRACELETS.find(el => el.label === oldBracelet?.bracelet)}
                            logo={logo}
                            date={oldBracelet?.date}
                        />
                        <Tooltip title={t('buttons.delete')} placement="bottom" arrow>
                            <IconButton
                                size="small"
                                onClick={() =>
                                    handleDeleteBracelet(BRACELETS.find(el => el.label === oldBracelet?.bracelet))
                                }
                                disableRipple
                                sx={{
                                    ml: 0.5,
                                    color: 'text.secondary',
                                    transition: 'color .15s ease-in-out, background-color .15s ease-in-out',
                                    bgcolor: 'transparent',
                                    '&:hover': { color: 'text.primary', bgcolor: 'action.hover' },
                                }}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                ) : null}

                <Collapse in={!listControl && braceletInfo !== null && braceletInfo?.bracelet}>
                    <Typography variant={'caption'} textAlign={'left'}>
                        {t('bracelets.Apply Bracelet')}:
                    </Typography>
                    <Bracelet i18n={i18n} bracelet={BRACELETS.find(el => el.label === selectedBracelet)} logo={logo} />
                </Collapse>

                <Collapse
                    in={
                        !braceletInfo?.selected &&
                        typeof oldBracelet?.bracelet === 'string' &&
                        oldBracelet?.bracelet === ''
                    }
                >
                    <Typography variant={'caption'} textAlign={'left'}>
                        {t('bracelets.Choose Bracelet')}
                    </Typography>
                </Collapse>

                {!listControl && braceletInfo !== null && braceletInfo?.bracelet && (
                    <DatePicker
                        label={t('bracelets.activationDate')}
                        name="startDate"
                        value={activationDate}
                        onChange={date => setActivationDate(date)}
                        format="dd.MM.yyyy"
                        slotProps={{
                            textField: {
                                variant: 'outlined',
                                fullWidth: true,
                            },
                        }}
                    />
                )}
                <Button
                    onClick={() => setListControl(value => !value)}
                    style={{
                        borderRadius: listControl ? '7px 7px 0px 0px' : '7px',
                        boxShadow: 'unset',
                    }}
                    endIcon={
                        <ArrowDropDown
                            style={{
                                transform: listControl ? 'rotate(180deg)' : '',
                                transition: '0.2s',
                            }}
                        />
                    }
                    variant={'contained'}
                >
                    {t('bracelets.Bracelets')}
                </Button>

                <Collapse in={listControl} style={{ margin: '0' }}>
                    <Paper
                        elevation={1}
                        style={{
                            padding: '0px 0px 20px 20px',
                            backgroundColor: '#e0e0e0',
                            borderRadius: 'unset',
                        }}
                    >
                        <Stack spacing={1}>
                            {BRACELETS.filter(
                                el => el.label !== selectedBracelet && el.label !== oldBracelet?.bracelet
                            ).map((bracelet, i) => {
                                const prevBracelet = allActiveBracelets.find(el => el.bracelet === bracelet.label);
                                const prevDate = prevBracelet?.date || null;
                                return (
                                    <Box
                                        key={bracelet.label + i}
                                        sx={{
                                            position: 'relative',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Bracelet
                                            selectBracelet={selectBracelet}
                                            i18n={i18n}
                                            bracelet={bracelet}
                                            logo={logo}
                                            date={prevDate}
                                        />
                                        <Tooltip title={t('buttons.delete')} placement="bottom" arrow>
                                            <IconButton
                                                size="small"
                                                onClick={() => handleDeleteBracelet(bracelet)}
                                                disableRipple
                                                sx={{
                                                    ml: 0.5,
                                                    color: 'text.secondary',
                                                    transition:
                                                        'color .15s ease-in-out, background-color .15s ease-in-out',
                                                    bgcolor: 'transparent',
                                                    '&:hover': { color: 'text.primary', bgcolor: 'action.hover' },
                                                }}
                                            >
                                                <Delete fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                );
                            })}
                        </Stack>
                    </Paper>
                </Collapse>
            </Stack>

            <DialogActions>
                <Button className="request-button orangeButton" onClick={() => dispatch(props.closeRequestModal)}>
                    {t('buttons.cancel')}
                </Button>
                <Button
                    variant="contained"
                    className="request-button greenButton"
                    onClick={() => editUser()}
                    disabled={!braceletInfo?.selected || !activationDate}
                >
                    {t('buttons.apply')}
                </Button>
            </DialogActions>
        </Box>
    );
};

const widthConnect = connect(
    state => ({}),
    dispatch => bindActionCreators({ closeRequestModal }, dispatch)
);

export { Bracelet };

export default withTranslation()(widthConnect(EditStudentBracelet));
